import React, { useMemo, useState } from "react";
import { ArtworkLibraryProvider } from "../../artwork-library/context";
import ArtworkLibrary from "../../artwork-library/ArtworkLibrary";
import type { ArtworkLibrarySelectedFile } from "../utils";

import "./ArtworkPicker.css";

interface ArtworkPickerProps {
  parent_type: string;
  parent_id: string;
  account_id: string;
  value: string | undefined;
  onSelect: (file: ArtworkLibrarySelectedFile) => void;
}
 
export const ArtworkPicker: React.FC<ArtworkPickerProps> = ({ parent_type, parent_id, account_id, onSelect, value }) => {
  const [isSelectingLogo, setIsSelectingLogo] = useState<boolean>(false);

  const initParent = useMemo(() => ({ parent_type, parent_id }), [parent_type, parent_id]);
  const initParents = useMemo(() => [initParent, { parent_type: 'CLIENT', parent_id: account_id }], [initParent, account_id]);

  return (
    <>
      <ArtworkLibraryProvider
        initParents={initParents}
        initParent={initParent}
        isModal
        modalOpen={isSelectingLogo}
        setModalOpen={setIsSelectingLogo}
        onFileSelect={onSelect}
      >
        <ArtworkLibrary />
      </ArtworkLibraryProvider>
      <div onClick={() => setIsSelectingLogo(true)} className="artwork-picker-container">
        {value && <img src={value} alt="Logo" />}
        <p>Change Artwork</p>
      </div>
    </>
  );
}
